import { FAQ_FAQ_INDEX_SET_DATA } from 'rebook/apps/faq/constants';


const initialState = {
  sections: null,
};

export default function faqIndex(state = initialState, action) {
  switch (action.type) {
    case FAQ_FAQ_INDEX_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
